// https://github.com/vercel-labs/await-interaction-response

/**
 *
 * await interactionResponse();
 *
 * если хочется обкостылить INP то вот оно
 */
export default function interactionResponse(): Promise<unknown> {
  return new Promise((resolve) => {
    if (typeof requestAnimationFrame !== 'function') {
      setTimeout(resolve, 0);
      return;
    }
    const fallbackTimeoutHandle = setTimeout(resolve, 10); // Fallback for the case where the animation frame never fires.
    requestAnimationFrame(() => {
      clearTimeout(fallbackTimeoutHandle);
      setTimeout(resolve, 0);
    });
  });
}
